module.exports = __webpack_public_path__ + "static/media/weather.b423bc3b.svg";